// src/services/statistics.service.js
import apiClient from './api.service';

class StatisticsService {
  async getStatistics(userId, viewType = 'months', value = 6) {
    try {
      const response = await apiClient.get('/statistics', {
        params: {
          userId,
          viewType,
          value
        }
      });
      return response.data;
    } catch (error) {
      console.error('Failed to fetch statistics:', error);
      throw error;
    }
  }
}

const statisticsService = new StatisticsService();
export default statisticsService;